<div class="bg-card border rounded shadow-sm p-2 mb-3">
    <adaa-table-legend-data-entry [showActions]="false" />
    <div #hotTableContainer></div>
</div>
